import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SignedOut from './pages/SignedOut';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/signed-out" element={<SignedOut />} >
        </Route>
      </Routes>
    </Router>
  );
}

export default App;